import type { SecretId, SecretListing } from "@repo/app-types/entities/secret";
import xor from "lodash-es/xor.js";

/**
 * The ids of the secrets the form references, or `undefined` when they are
 * the ones referenced when it loaded, so a save leaves the references alone.
 */
export function buildCodeToolSecretIds(
  secrets: readonly SecretListing[],
  storedSecrets: readonly SecretListing[],
): SecretId[] | undefined {
  const ids = secrets.map(({ id }) => id);
  const storedIds = storedSecrets.map(({ id }) => id);
  return xor(ids, storedIds).length === 0 ? undefined : ids;
}
